import { Box, Button, Image, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cornerSketch from 'assets/img/sketches/private_channel_corner_sketch.svg';
import { ButtonVariant } from 'presentation/theme/components/button';

interface Props {
  onSubmit: () => void;
}

const PrivateChannelNoAccessCard: FC<Props> = ({ onSubmit }) => {
  const { t } = useTranslation();

  return (
    <AppCard
      w="352px"
      h="324px"
      bgColor="#323232"
      bgImage="linear-gradient(180deg, #848484 0%, rgba(132, 132, 132, 0) 100%)"
      pos="relative"
    >
      <Image
        src={cornerSketch}
        h="140px"
        pos="absolute"
        bottom="45px"
        right="0"
      />
      <Box
        p="15px"
        pos="relative"
        display="flex"
        flexDir="column"
        h="100%"
        justifyContent="space-between"
      >
        <Box>
          <Text mb="10px" fontSize="18px" color="#fff" fontWeight={700}>
            {t('privateChannelNoAccessTitle')}
          </Text>
          <Text color="#fff">{t('privateChannelNoAccessText')}</Text>
        </Box>
        <Button onClick={onSubmit} variant={ButtonVariant.Primary}>
          {t('joinCommunity')}
        </Button>
      </Box>
    </AppCard>
  );
};

export default PrivateChannelNoAccessCard;
